import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-BigRows",
  "use": "svg-icon-BigRows-usage",
  "viewBox": "0 0 22 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 14\" id=\"svg-icon-BigRows\"><path fill=\"#333\" fill-rule=\"evenodd\" d=\"M1 0h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 0h15a1 1 0 0 1 1 1v3.625a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zM1 8.375h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1zm5 0h15a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9.375a1 1 0 0 1 1-1z\" opacity=\".3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol